import { FC } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';

import { BoardVideo } from 'types';
import ToggleMenu from 'modules/_shared/components/ToggleMenu';

type VideoRowProps = {
  video: BoardVideo;
  hasOptions?: boolean;
  isAdminView?: boolean;
  onViewVideo: (videoId: string) => void; // eslint-disable-line no-unused-vars
  onRenameVideo?: (videoId: string) => void; // eslint-disable-line no-unused-vars
  onDeleteVideo?: (videoId: string) => void; // eslint-disable-line no-unused-vars
  textSize?: number;
};

const VideoRow: FC<VideoRowProps> = ({
  video,
  hasOptions = true,
  isAdminView = true,
  onViewVideo,
  onRenameVideo,
  onDeleteVideo,
  textSize = 250,
}) => {
  const { t } = useTranslate();

  const videoIcon = (
    <em className="icon ni ni-play-circle" style={{ fontSize: '24px' }} />
  );

  const availableOptions = {
    VIEW: (
      <Dropdown.Item
        key={`video-view-option-${video.videoId}`}
        onClick={() => onViewVideo(video.videoId)}
      >
        <em className="icon ni ni-eye fs-20px" />
        <span>{t('See') || 'View'}</span>
      </Dropdown.Item>
    ),
    RENAME:
      isAdminView && onRenameVideo ? (
        <Dropdown.Item
          key={`video-rename-option-${video.videoId}`}
          onClick={() => onRenameVideo(video.videoId)}
        >
          <em className="icon ni ni-edit fs-20px" />
          <span>{t('Rename') || 'Rename'}</span>
        </Dropdown.Item>
      ) : null,
    DELETE:
      isAdminView && onDeleteVideo ? (
        <Dropdown.Item
          key={`video-delete-option-${video.videoId}`}
          onClick={() => onDeleteVideo(video.videoId)}
        >
          <em className="icon ni ni-trash fs-20px" />
          <span>{t('Delete') || 'Delete'}</span>
        </Dropdown.Item>
      ) : null,
  };

  const toggleOptions = [
    availableOptions.VIEW,
    availableOptions.RENAME,
    availableOptions.DELETE,
  ].filter(Boolean);

  return (
    <div className="nk-files-list">
      <div className="nk-file-item nk-file">
        <div className="nk-file-info">
          <div className="nk-file-title">
            <div className="nk-file-icon">
              <span className="nk-file-icon-type">{videoIcon}</span>
            </div>
            <div className="nk-file-name">
              <div
                className={`w-${textSize}px d-block text-ellipsis cursor-pointer`}
                onClick={() => onViewVideo(video.videoId)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onViewVideo(video.videoId);
                  }
                }}
                style={{
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.textDecoration = 'underline';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.textDecoration = 'none';
                }}
              >
                <span>{video.title}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="nk-file-members">
          <div className="tb-lead">
            {video.date
              ? format(
                  new Date(
                    typeof video.date === 'string' ? video.date : video.date
                  ),
                  'dd/MM/yy'
                )
              : '-'}
          </div>
        </div>

        {!isAdminView && hasOptions && (
          <div className="nk-file-meta pr-4">
            <ToggleMenu toggleOptions={toggleOptions} />
          </div>
        )}

        {isAdminView && hasOptions && (
          <div className="nk-file-meta pr-4">
            <ToggleMenu toggleOptions={toggleOptions} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoRow;
